//
//
//
//
//

export default {
  name: "BlueTagItem",
  props: ["tag", "removeTag"],
};
